module.exports = __webpack_public_path__ + "img/404.97f0749d.jpg";